<!--eslint-disable-->
<template>

    <div class="position-relative">
        <div>
            <img src="@/assets/images/banner.png" alt="loading" class="w-100" >
        </div>
        <div class="image-container">
            <img src="@/assets/images/icon2.png" alt="Carregando..." height="300">
            <div class="loading-shine"></div>
        </div>
    </div>
</template>


<script setup>



</script>

<style scoped>

.image-container {
    position: absolute;
    display: inline-block;
    overflow: hidden; /* Garante que o brilho não passe os limites da imagem */
    top: calc(50% - 150px);
    left: calc(50% - 150px);
    opacity: .5;
}

.image-container img {
    display: block;
}

.loading-shine {
    position: absolute;
    top: 0;
    left: -100%; /* Inicia fora da tela */
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 70%);
    animation: shine 1.2s infinite;
}

@keyframes shine {
    to {
        left: 100%; /* Move o brilho da esquerda para a direita */
    }
}

</style>
